export default {
    methods: {
        /**
         * Translate the given key.
         */
        __(key, replace) {
            // @todo change
            return key;
            
            var translation = window.config.translations[key]
            ? window.config.translations[key]
            : key;

            _.forEach(replace, (value, key) => {
                translation = translation.replace(':' + key, value);
            });

            return translation;
        },

        capitalize() {
            if (!value && value !== 0) {
                return "";
            }

            return (
                value
                    .toString()
                    .charAt(0)
                    .toUpperCase() + value.slice(1)
            );
        }
    }
};
